export const PAGES = {
  ADDRESS: 'address',
  HOMEOWNER_LIST: 'homeowner-list',
  WINDOW_COUNT: 'window-count',
  DOOR_COUNT: 'door-count',
  WINDOW_ISSUES: 'window-issues',
  DO_NOT_SERVICE_AREA: 'do-not-service-area',
  ADDITIONAL_COMMENTS: 'additional-comments',
  EXPLORE_RESOURCES: 'explore-resources',
  ENERGY_EFFICIENCY: 'energy-efficiency',
  FINANCING_PLANS: 'financing-plans',
  FINANCING_EDUCATION: 'financing-education',
  INSTALLATION_PROCESS: 'installation-process',
  CONFIRMATION: 'confirmation',
  TIME_DATE_BOOKING: 'time-date-booking',
  SOURCE_TYPE: 'source-type',
  EMBED_GET_STARTED: 'embed-get-started',
  PROJECT_DETAILS: 'project-details',
  PROJECT_DETAILS_SUBMITTED: 'project-details-submitted',
  COMMENTS_SUBMITTED: 'comments-submitted'
};

export const WITHOUT_ID_WHITELIST = [
  PAGES.EMBED_GET_STARTED,
  '',
];

export const PAGES_TO_VALIDATE_RANDOM_NAVIGATION = [
  PAGES.ADDRESS,
  PAGES.HOMEOWNER_LIST,
  PAGES.WINDOW_COUNT,
  PAGES.WINDOW_ISSUES,
  PAGES.ADDITIONAL_COMMENTS,
  PAGES.TIME_DATE_BOOKING,
  PAGES.SOURCE_TYPE,
];

export const NAVIGATION_MAP = {
  [PAGES.ADDRESS]: {
    nextButton: {
      text: 'Next',
      route: PAGES.TIME_DATE_BOOKING,
    },
    backButton: {
      text: 'Back',
      route: PAGES.SOURCE_TYPE,
    },
    dataName: 'addressInfo',
    status: { activeIndex: 1 },
  },
  [PAGES.HOMEOWNER_LIST]: {
    nextButton: {
      text: 'Next',
      route: PAGES.SOURCE_TYPE,
    },
    backButton: {
      text: 'Back',
      route: PAGES.WINDOW_ISSUES,
    },
    status: { activeIndex: 0 },
    dataName: 'homeownerInfo',
  },
  [PAGES.WINDOW_COUNT]: {
    nextButton: {
      text: 'Next',
      route: PAGES.WINDOW_ISSUES,
    },
    backButton: {
      text: 'Back',
      route: '',
    },
    status: { activeIndex: 1 },
    dataName: 'windowCount',
  },
  [PAGES.WINDOW_ISSUES]: {
    nextButton: {
      text: 'Next',
      route: PAGES.HOMEOWNER_LIST,
    },
    backButton: {
      text: 'Back',
      route: PAGES.WINDOW_COUNT,
    },
    status: { activeIndex: 1 },
    dataName: 'windowIssues',
  },
  [PAGES.DO_NOT_SERVICE_AREA]: {
    dataName: 'doNotServiceArea',
    exitButton: {
      text: 'Exit Form',
      route: '',
    },
  },
  [PAGES.ADDITIONAL_COMMENTS]: {
    dataName: 'additionalComments',
    nextButton: {
      text: 'Submit',
      route: PAGES.EXPLORE_RESOURCES,
      position: 'center',
      noIcon: true,
    },
  },
  [PAGES.EXPLORE_RESOURCES]: {
    dataName: 'exploreResources',
  },
  [PAGES.ENERGY_EFFICIENCY]: {
    backButton: {
      text: 'Back',
      route: PAGES.EXPLORE_RESOURCES,
      useHistory: true,
    },
    dataName: 'energyEfficiency',
  },
  [PAGES.FINANCING_PLANS]: {
    backButton: {
      text: 'Back',
      route: PAGES.EXPLORE_RESOURCES,
      useHistory: true,
    },
    dataName: 'financingPlans',
  },
  [PAGES.FINANCING_EDUCATION]: {
    backButton: {
      text: 'Back',
      route: PAGES.EXPLORE_RESOURCES,
      useHistory: true,
    },
    dataName: 'financingEducation',
  },
  [PAGES.INSTALLATION_PROCESS]: {
    backButton: {
      text: 'Back',
      route: '',
      useHistory: true,
    },
    dataName: 'installationProcess',
  },
  [PAGES.TIME_DATE_BOOKING]: {
    dataName: 'timeDateBooking',
    nextButton: {
      text: 'Book appointment',
      route: PAGES.ADDITIONAL_COMMENTS,
    },
    backButton: {
      text: 'Back',
      route: PAGES.ADDRESS,
    }
  },
  [PAGES.SOURCE_TYPE]: {
    nextButton: {
      text: 'Next',
      route: PAGES.ADDRESS,
    },
    backButton: {
      text: 'Back',
      route: PAGES.HOMEOWNER_LIST,
    },
    status: { activeIndex: 1 },
    dataName: 'sourceType',
  },
  [PAGES.PROJECT_DETAILS_SUBMITTED]: {
    dataName: 'insideSales',
    exitButton: {
      text: 'Exit Form',
      route: '',
    },
  },
  [PAGES.COMMENTS_SUBMITTED]: {
    dataName: 'insideSales'
  },
  [PAGES.PROJECT_DETAILS]: {
    nextButton: {
      text: 'Next',
      route: PAGES.PROJECT_DETAILS_SUBMITTED,
    },
    backButton: {
      text: 'Back',
      route: PAGES.ADDRESS,
    },
    status: { activeIndex: 1 },
    dataName: 'sourceType',
  },
};
